import {BreadcrumContext} from '@shared/components'
import {PropsWithChildren, useMemo, useState} from 'react'
import {useNavigate} from 'react-router-dom'

export type BreadcrumListType = {
  title: string
  onClick: () => void
}[]

export const BreadcrumProvider = ({children}: PropsWithChildren<any>) => {
  const navigate = useNavigate()
  const [items, setItems] = useState<BreadcrumListType>([
    {
      title: 'Customers',
      onClick: () => {
        navigate('/')
      },
    },
  ])

  const values = useMemo(() => ({items, setItems}), [])

  return <BreadcrumContext.Provider value={values}>{children}</BreadcrumContext.Provider>
}
